import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { HardwareProvider } from "./context/HardwareContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import Diagnostic from "./pages/Diagnostic";
import Catalog from "./pages/Catalog";
import Trending from "./pages/Trending";
import Compare from "./pages/Compare";
import Profiles from "./pages/Profiles";
import Assistant from "./pages/Assistant";
import Login from "./pages/Login";
import Register from "./pages/Register";
import About from "./pages/About";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import InstallGuide from "./pages/InstallGuide";
import Favorites from "./pages/Favorites";
import SharedFavorites from "./pages/SharedFavorites";
import Mobile from "./pages/Mobile";
import SharedDiagnostic from "./pages/SharedDiagnostic";
import { FavoritesProvider } from "./context/FavoritesContext";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <AuthProvider>
          <HardwareProvider>
          <FavoritesProvider>
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Diagnostic />} />
                <Route path="/catalogue" element={<Catalog />} />
                <Route path="/tendances" element={<Trending />} />
                <Route path="/comparateur" element={<Compare />} />
                <Route path="/profils" element={<Profiles />} />
                <Route path="/assistant" element={<Assistant />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/favoris" element={<Favorites />} />
                <Route path="/favoris/partage" element={<SharedFavorites />} />
                <Route path="/favoris/partage/:token" element={<SharedFavorites />} />
                <Route path="/diagnostic/partage" element={<SharedDiagnostic />} />
                <Route path="/iphone" element={<Mobile />} />
                <Route path="/installation" element={<InstallGuide />} />
                <Route path="/compte" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-right" offset={80} richColors />
          </FavoritesProvider>
          </HardwareProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
